<template>
  <div id="app">
    <LoadingScreen :isLoading="isLoading" v-if="isLoading"/>
    <CookieConsent/>
<!--    <MenuBar class="menu-bar"/>-->
    <main>
      <div class="main-content">
        <router-view/>
      </div>
    </main>
    <footer>
      <div class="footer-cookie no-print">
        <a @click="showCookieBanner">{{getTranslation('cookie-consent-subtitle')}}</a>
      </div>
      
      <div class="footer-title-text no-print">
        <p>
         Powered By
        </p>
      </div>
      <div class="footer-partners">
        <div class="footer-powered-by" @click="navigateTo('https://fiveamtech.it?utm_source=masticando&utm_medium=referral')">
          <img
              src="https://fiveamtech.it/logo-nobg.png"
              alt="Fiveam Tech"
              class="fiveam-logo"
              style="height: 60px; width: auto;"
          >
        </div>
        <div class="footer-cinopedia" @click="navigateTo('https://cinopedia.cloud?utm_source=masticando&utm_medium=referral')">
          <img
              src="/img/logo_cinopedia.png"
              alt="Cinopedia"
              class="cinopedia-logo"
              style="height: 40px; width: auto;"
          >
        </div>
      </div>
      
      <div class="footer-cookie no-print">
        <p>
          © 2025 Masticando All rights reserved.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import LoadingScreen from "@/components/LoadingScreen.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import {getTranslation} from "@/services/stringTableService";

const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _ = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce (callback, 20);
    super(callback);
  }
};

export default {
  name: 'App',
  components: {LoadingScreen, CookieConsent},
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    }
  },
  methods: {
    getTranslation(value) {
      return getTranslation("it", value);
    },
    showCookieBanner() {
      this.$store.dispatch('setShowCookieBanner', true);
    },
    navigateTo(url) {
      window.location.href = url
    },
    loadTheme() {
      const theme = localStorage.getItem('isDarkTheme');
      if (theme === null) {
        this.$store.dispatch('setTheme', true);
      } else {
        this.$store.dispatch('setTheme', theme === 'true');
      }

    }
  },
  async created() {
    this.$store.dispatch('setLoading', true);
    await this.$store.dispatch('validateToken');
    this.loadTheme();
    this.$store.dispatch('setLoading', false);
  }
}
</script>

<style lang="scss">
@import './style/_variables.scss';

#app {
  overflow-y: hidden;
}
body {
  overflow-y: auto;
  background-color: $background-color;
  width: 100vw;
  height: 100dvh;
  font-family: $font-base;
}
.main-content {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  width: 100%;
  @media (max-width: 700px) {
    padding: 0;
  }
}
main {
  min-height: $main-min-height;
  .countdown-container {
    //background-color: rgba($primary-color,0.1);
    //-webkit-box-shadow: 0px 0px 5px 5px rgba($primary-color,0.64);
    //box-shadow: 0px 0px 5px 5px rgba($primary-color,0.64);
    background-color: $secondary-background-color;
    //border-radius: 5px;
    //padding: 0 5px 5px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .countdown {
      width: 100%;
      margin-top: 20px;
      padding: 20px;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        span {
          font-size: 3rem;
          font-family: $header-font;
          font-weight: bold;
        }
        .countdown-number {
          font-size: 3rem;
          font-family: $header-font;
          font-weight: bold;
          transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
        }

        .countdown-number-enter-active,
        .countdown-number-leave-active {
          transform: scale(1.2);
          opacity: 0.5;
        }
      }
    }
  }
}
footer {
  min-height: $footer-height;
  background-color: $footer-background-color;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 25px; // Added padding as requested + some extra for safety
  
  .footer-cookie {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    gap: 5px;
    text-align: center;
    margin-bottom: 20px; // Increased separation
    a {
      font-family: $header-font;
      cursor: pointer;
    }
    @media print {
      display: none !important;
    }
  }  
  .footer-title-text {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    gap: 5px;
    text-align: center;
    @media print {
      display: none !important;
    }
  }
  .footer-partners {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 3rem;
    flex-wrap: wrap;
    align-items: center;
    div{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &:hover {
        cursor: pointer;
        img {
          filter: none;
          transform: scale(1.1);
        }
        p {
          color: $primary-color;
          transform: scale(1.1);
        }
      }

      @media print {
        img {
          filter: none;
          transform: scale(1.1);
        }
        p {
          display: none;
        }
        &::after {
          content: "Masticando";
          font-family: $header-font;
          font-size: 1.5rem;
          text-transform: uppercase;
        }

      }

      p {
        transition: transform 0.3s ease;
        color: $footer-text-color;
        font-family: Roboto, sans-serif;
        font-size: 0.8rem;
      }
      img {
        transition: transform 0.3s ease;
        filter: grayscale(100%);
        opacity: 0.8;
        width: 60px;
      }
    }
    
    .footer-powered-by {
      text-align: center;
      
      p {
        font-size: 0.7rem !important;
        letter-spacing: 2px;
        color: white;
      }
      
      img.fiveam-logo {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.3)) !important;
        opacity: 1 !important;
        transition: transform 0.3s ease;
        
        &:hover {
           transform: scale(1.1) !important;
           filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.6)) !important;
        }
      }
    }

    .footer-cinopedia {
      margin-left: 2rem;
      text-align: center;
      
      p {
        font-size: 0.7rem !important;
        letter-spacing: 2px;
        color: white;
        margin-bottom: 8px;
        font-weight: bold;
      }
      
      img.cinopedia-logo {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.3)) !important;
        opacity: 1 !important;
        transition: transform 0.3s ease;
        
        &:hover {
           transform: scale(1.1) !important;
           filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.6)) !important;
        }
      }
    }
  }

}

::-webkit-scrollbar {
  width: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}



div.v-list-item-title {
  white-space: normal;
  text-overflow: unset;
  text-transform: uppercase;
}
button.v-expansion-panel-title--active {
  background-color: $primary-color;
  color: $primary-contrast-color;
}
@keyframes moveUp {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-20%);
    opacity: 0;
  }
}

@keyframes moveDown {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.countdown-number {
  font-size: 3rem;
  font-family: $header-font;
  font-weight: bold;
  position: relative;
  display: inline-block;
}

.countdown-number.old {
  animation: moveUp 0.2s forwards;
}

.countdown-number.new {
  animation: moveDown 0.2s forwards;
}
</style>